import http from '@services/http'

export default {
  getJournalList(data: object): Promise<any> {
    return http.get('user-api/journal/list', data || {})
  },

  getJournalDetail(data: any): Promise<any> {
    return http.get(`user-api/journal/detail/${data.id}`, data || {})
  },

  getJournalYearList(data: object): Promise<any> {
    return http.get('user-api/journal/yearList', data || {})
  },

  getJournalVolumeList(data: object): Promise<any> {
    return http.get('user-api/journal/volumeList', data || {})
  },

  getJournalIssueList(data: object): Promise<any> {
    return http.get('user-api/journal/issueList', data || {})
  },
  getJcrList(data: any): Promise<any> {
    return http.get(`user-api/na/journal/jcrList/${data.id}`, data || {})
  },

  subscribeSave(data: any): Promise<any> {
    return http.get('user-api/subscribe/save', data || [])
  }
}
